import React from 'react';
import logo from '../../assets/logo/raz-logob.png'

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import ShoppingBasketOutlined from '@material-ui/icons/ShoppingBasketOutlined';
import AttachMoneyOutlined from '@material-ui/icons/AttachMoneyOutlined';
import MailOutlineOutlined from '@material-ui/icons/MailOutlineOutlined';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';

import Nav2 from './nav2';
import Orders from '../orders/orders';

import PaymentNotice from '../paymentNotice/paymentNotice';

import CurrentAccount from '../currentAccount/currentAccount';

import { Paper, Container } from '@material-ui/core';
import PriceList from '../priceLists/priceList';
import Administration from '../administration/Administration'
import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { getFromAPI } from '../helpers/sqlApiCalls';
import { styled } from '@material-ui/styles';
import MyInfo from '../myInfo/MyInfo';
import Documents from '../documents/Documents';
import Extensiones from '../documents/Extensions';


const useStyles = makeStyles((theme) => ({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  root1: {
    flexGrow: 1,
  },
  container: {
    maxHeight: 440,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  iconPadded: {
    marginRight: 10
  },
  paddedTop: {
    paddingTop: 120
  },
  toolBarStyle: {
    [theme.breakpoints.up('sm')]: {
      paddingRight: 104,
      paddingLeft: 104
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: 48,
      paddingLeft: 48
    },
  },
  appBarStyle: {
    // color: theme.palette.nav1.header
    backgroundColor: theme.palette.nav.header
  },
  userColor: {
    color: '#FFF'
  }
}));

function TabPanel(props) {

  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div>
          {children}
        </div>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
class Nav1 extends React.Component {

  constructor(props) {
    super(props)
    this.stock = {}
    this.pricelist = {}
  }

  componentDidMount() {
    this.clData = JSON.parse(localStorage.clData)
    this.defaultConfig = JSON.parse(localStorage.defaultConfig)
    // this.getData()
  }

  render() {
    return (<Nav1FN props={this.props} Logout={() => { this.props.Logout() }}></Nav1FN>)
  }
}

function Nav1FN(props) {

  const classes = useStyles();
  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [viewUse, updateView] = React.useState(1)
  const [value, setValue] = React.useState(-1);
  const user = JSON.parse(localStorage.user)


  const handleChange2 = (event, newValue) => {
    setValue(newValue);
  };

  const changeView = (newValue, view) => {
    setValue(newValue);
    updateView(view)
  };


  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Typography variant="button" > <IconButton
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"

        color="inherit"
      >
        <PersonOutlineOutlinedIcon />
      </IconButton> Bienvenido {JSON.parse(localStorage.clInfo) && JSON.parse(localStorage.clInfo).bn ? JSON.parse(localStorage.clInfo).bn : user.n} </Typography>
      <List>
        {/* <ListItem button onClick={() => { changeView(0, 2) }} >
          <ListItemIcon> <ShoppingBasketOutlined /></ListItemIcon>
          <ListItemText primary={"Pedidos"} />
        </ListItem> */}

        {(user.screensAccess && user.screensAccess.currentAcount) &&
          <ListItem button onClick={() => { changeView(1, 2) }}>
            <ListItemIcon> <AttachMoneyOutlined /></ListItemIcon>
            <ListItemText primary={"Cuenta corriente"} />
          </ListItem>
        }

        {(user.screensAccess && user.screensAccess.paymentNotice) &&
          <ListItem button onClick={() => { changeView(2, 2) }}>
            <ListItemIcon> <MailOutlineOutlined /></ListItemIcon>
            <ListItemText primary={"Aviso de pago"} />
          </ListItem>
        }

        {(user.screensAccess && user.screensAccess.priceList) &&
          <ListItem button onClick={() => { changeView(7, 7) }}>
            <ListItemIcon> <AssignmentOutlinedIcon style={{ fontSize: 40, color: "#0f5591" }} ></AssignmentOutlinedIcon></ListItemIcon>
            <ListItemText primary={"Lista de precios"} />
          </ListItem>  
        }
        
        
        
        {/* <ListItem button onClick={() => { changeView(3, 2) }}>
          <ListItemIcon> <InfoOutlined /></ListItemIcon>
          <ListItemText primary={"Catálogo"} />
        </ListItem> */}
      </List>
      <Divider />
      <List>
        <ListItem button onClick={() => { props.Logout(); localStorage.clData = ""; localStorage.sellerCode = ""; localStorage.stayLoggedIn = "false" }}>
          <ListItemIcon><CloseIcon /></ListItemIcon>
          <ListItemText primary={"cerrar sesion"} />
        </ListItem>
      </List>
    </div>
  );

  return (
    <div className={classes.root}>
      {/* <Container maxWidth="lg"> */}

      <AppBar elevation={0} className={classes.appBarStyle} color="secondary" position="fixed">
        <Toolbar className={classes.toolBarStyle}>

          <img loading='lazy' style={{ maxWidth: 180, padding: '8px 0px' }} alt="logo-dielfe" onClick={() => changeView(null, 1)} src={logo} ></img>

          <Typography variant="h6" className={classes.title}>

          </Typography>

          {auth && (
            <div >
              <div className="bigscreen">
                <Typography className={classes.userColor} variant="button" >Bienvenido {JSON.parse(localStorage.clInfo) && JSON.parse(localStorage.clInfo).bn ? JSON.parse(localStorage.clInfo).bn : user.n}</Typography>

                <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  // color="inherit"
                  className={classes.userColor}
                >
                  <PersonOutlineOutlinedIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={open}
                  onClose={handleClose}
                >
                  <MenuItem onClick={() => { changeView(4, 3); handleClose() }}><PersonOutlineOutlinedIcon className={classes.iconPadded} />Mi Información</MenuItem>
                  {/* <MenuItem onClick={handleClose}><SettingsOutlinedIcon className={classes.iconPadded} />Configuración</MenuItem> */}
                  {/* <MenuItem onClick={handleClose}><HelpOutlineOutlinedIcon className={classes.iconPadded} />Ayuda</MenuItem> */}
                  <MenuItem onClick={() => { props.Logout(); localStorage.clData = ""; localStorage.sellerCode = ""; localStorage.stayLoggedIn = "false" }}><CloseIcon className={classes.iconPadded} />Cerrar Sesión</MenuItem>
                </Menu>
              </div>
              <div className="smallscreen">
                <React.Fragment key={"left"}>
                  <Button onClick={toggleDrawer("left", true)}> <IconButton
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    // color="inherit"
                    className={classes.userColor}
                  >
                    <MenuIcon />
                  </IconButton></Button>
                  <Drawer anchor={"left"} open={state["left"]} onClose={toggleDrawer("left", false)}>
                    {list("left")}
                  </Drawer>
                </React.Fragment>

              </div>
              <Typography className={classes.userColor} style={{
                marginTop: '-10px',
                marginLeft: '-1px',
                fontSize: 14,
                fontWeight: 'bold'
              }}>CODIGO DE CLIENTE: {JSON.parse(localStorage.user) && JSON.parse(localStorage.user).k ? JSON.parse(localStorage.user).k : 'Sin asignar'}</Typography>
            </div>

          )}
        </Toolbar>
        {viewUse === 2 ?
          <Tabs className={[classes.root, "bigscreen2"]} value={value} onChange={handleChange2}
            indicatorColor="secondary"
            textColor="secondary"
            centered
            TabIndicatorProps={{
              style: {
                display: "none",
              },
            }}
            // variant="scrollable"
            scrollButtons="auto"
            // allowScrollButtonsMobile
            aria-label="simple tabs example"
          >
            {/* <Tab wrapped value={0} label="Pedidos" {...a11yProps(0)} /> */}


            {(user.screensAccess && user.screensAccess.currentAcount) &&
              <Tab wrapped value={1} label="Cuenta Corriente" {...a11yProps(1)} />
            }

            {(user.screensAccess && user.screensAccess.paymentNotice) &&
              <Tab wrapped value={2} label="Avisos de pago" {...a11yProps(2)} />
            }

            {(user.screensAccess && user.screensAccess.priceList) &&
              <Tab wrapped value={7} label="Lista de precios" {...a11yProps(7)} />
            }
            
            {/* <Tab label="Consulta" {...a11yProps(3)} /> */}
            {/* <Tab wrapped label="Consulta" {...a11yProps(3)} /> */}
            {/* <Tab wrapped value={3} label="Catálogo" {...a11yProps(3)} /> */}
            
            {/* {JSON.parse(localStorage.admin) &&
              <Tab wrapped label="Administración" {...a11yProps(4)} />
            } */}
          </Tabs>
          :
          viewUse === 3 ?
            <Tabs className={[classes.root, classes.toolBarStyle, "bigscreen2"]} value={value} onChange={handleChange2}
              indicatorColor="secondary"
              textColor="secondary"
              TabIndicatorProps={{
                style: {
                  display: "none",
                },
              }}
              scrollButtons="auto"
              aria-label="simple tabs example"
            >
              <Tab wrapped value={4} label="Mi información" {...a11yProps(4)} />
              {/* {JSON.parse(localStorage.admin) &&
                <Tab wrapped value={5} label="Configuración" {...a11yProps(5)} />
              } */}
              <Tab wrapped value={6} label="Documentación alta" {...a11yProps(6)} />
              <Tab wrapped value={8} label="Exenciones" {...a11yProps(8)} />
            </Tabs>
            :
            null
        }
      </AppBar>

      {/* <TabPanel className={classes.paddedTop} value={value} index={0} >
        <Orders changeView={(x, y) => { changeView(x, y) }}></Orders>
      </TabPanel> */}
      <TabPanel className={classes.paddedTop} value={value} index={1}>
        <CurrentAccount></CurrentAccount>
      </TabPanel>
      <TabPanel className={classes.paddedTop} value={value} index={2}>
        <PaymentNotice changeView={(x, y) => { changeView(x, y) }}></PaymentNotice>
      </TabPanel>

    
      <TabPanel className={classes.paddedTop} value={value} index={7}>
      <PriceList changeView={(x, y) => { changeView(x, y) }}></PriceList>
      </TabPanel>
      
     
      {/* <TabPanel className={classes.paddedTop} value={value} index={4}>
      <Ask changeView={(x,y)=>{changeView(x,y)}}></Ask>
      </TabPanel> */}
      {/* <TabPanel className={classes.paddedTop} value={value} index={3}>
        {/* <Container maxWidth="lg" > */}
      {/* <div>
          <iframe class="holds-the-iframe" sandbox src="http://dielfe-catalogo.kiri.ar/muebles/" style={{ border: "none" }} width="100%" height="650px" title="prueba"></iframe>
        </div> */}
      {/* </Container> */}
      {/* <Admini changeView={(x, y) => { changeView(x, y) }}></PriceList> */}
      {/* <Administration changeView={(x, y) => { changeView(x, y) }} /> */}
      {/* </TabPanel> */}
      <TabPanel className={classes.paddedTop} value={value} index={4}>
        <MyInfo changeView={changeView} />
      </TabPanel>
      <TabPanel className={classes.paddedTop} value={value} index={6}>
        <Documents changeView={changeView} />
      </TabPanel>
      <TabPanel className={classes.paddedTop} value={value} index={8}>
        <Extensiones changeView={changeView} />
      </TabPanel>
      {
        viewUse === 1 ?
          <Nav2 changeView={changeView}></Nav2>
          :
          <div></div>
      }
      {/* </Container> */}
    </div>
  );
}
// function RenderNavigation(x) {
//   if (x === 1) {
//     return
//   }
//   return null

// }
export default Nav1;
